import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {
  StatusEventSignalValueParsingType
} from '@constants/machine/status-event-signal/status-event-signal-value-parsing-type.enum';
import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';
import {
  BIT_PARSING_MAX_ALLOWED_ERROR_CODES,
  VALUE_PARSING_MAX_ALLOWED_ERROR_CODES
} from '@constants/machine/status-event-signal/status-event-signal.constants';
import {StatusEventSignalParsingException} from '@models/machine/status-event-signal/status-event-signal-parsing-exception';
import {
  StatusEventExceptionTypes
} from '@constants/machine/status-event-signal/status-event-exception-types.enum';

@Injectable({
  providedIn: 'root'
})
export class StatusEventSignalValidatorService {
  private NEW_LINE: string = '</br>';

  constructor(private translate: TranslateService) {
  }

  public validateStatusEventDefinitions(parsingType: StatusEventSignalValueParsingType, definitions: Map<string, StatusEventDetails>): void {
    this.validateEventCodesCount(parsingType, definitions);

    this.validateEventCodes(parsingType, definitions);
  }

  private validateEventCodesCount(parsingType: StatusEventSignalValueParsingType, definitions: Map<string, StatusEventDetails>) {
    let maxNumberOfCodes: number = VALUE_PARSING_MAX_ALLOWED_ERROR_CODES;
    if (parsingType == StatusEventSignalValueParsingType.BIT) {
      maxNumberOfCodes = BIT_PARSING_MAX_ALLOWED_ERROR_CODES;
    }
    const definitionsSize = definitions.size;
    if (definitionsSize > maxNumberOfCodes) {
      let message = this.translate.instant('The defined number of event codes (%1) exceeds the max allowed number of %2 for parsing type %3');
      message = message.replace('%1', definitionsSize);
      message = message.replace('%2', maxNumberOfCodes + '');
      message = message.replace('%3', parsingType + '');
      throw new StatusEventSignalParsingException(StatusEventExceptionTypes.TOO_MANY_CODES, message);
    }

  }


  private validateEventCodes(parsingType: StatusEventSignalValueParsingType, definitions: Map<string, StatusEventDetails>): void {
    if (parsingType === StatusEventSignalValueParsingType.VALUE) {
      return;
    }
    const bitParsingInvalidCodes = new Set<string>();
    if (!definitions || definitions.size === 0) {
      return;
    }
    definitions.forEach((item: StatusEventDetails) => {
      const eventCode = item.code;
      if (!this.stringIsPositiveInteger(eventCode)) {
        bitParsingInvalidCodes.add(this.generateDetailsString(item));
      }

    });

    if (bitParsingInvalidCodes.size > 0) {
      let message = this.translate.instant('There are unsupported event codes defined. Import failure');
      message += this.NEW_LINE + Array.from(bitParsingInvalidCodes).join(';');
      console.log(message);
      throw new StatusEventSignalParsingException(StatusEventExceptionTypes.UNSUPPORTED_EVENT_CODES, message);
    }

  }

  private stringIsPositiveInteger(value: string): boolean {
    if (!value) {
      return false;
    }
    const number = Number(value);
    return Number.isInteger(number) && number >= 0;

  }

  private generateDetailsString(statusEventDetails: StatusEventDetails) {
    return statusEventDetails.code + ':' + statusEventDetails.type + ', ' + statusEventDetails.description;
  }

}
